<template>
  <v-snackbar
    :location="useUserStore().snackLocation"
    v-model="useUserStore().snackbar"
    :color="useUserStore().snackStatus"
    :timeout="useUserStore().snackTimeout"
  >
    <v-row no-gutters align="center">
      {{ useUserStore().messageSnack }}
      <v-spacer></v-spacer>
      <v-icon
        v-if="useUserStore().isSnackCloseable"
        class="ml-2"
        icon="mdi-close"
        size="small"
        @click="
          useUserStore().$patch({
            snackbar: false,
            isSnackCloseable: false,
            snackLocation: 'bottom center',
          })
        "
      ></v-icon
    ></v-row>
  </v-snackbar>
</template>
